import Axios from 'axios';
import qs from 'qs';
import { RawConfig } from './contexts/auth';

export async function healthGet(url, obj, meta) {
	const options = {
		method: 'GET',
		headers: {
			'health-auth': localStorage.getItem('id_token'),
			'Content-Type': 'application/json',
		},
		params: {
			...obj
		},
		url,
	}
	let res = {};
	try {
		// Validate session
		const sessionToken = localStorage.getItem('id_token');
		const parsed = JSON.parse(atob(sessionToken.split('.')[1]));
		const { exp } = parsed;
		const diff = exp - Date.now() / 1000;
		if (diff < 30) {
			// must refresh token	
			const obj = {
				grant_type: 'refresh_token',
				client_id: RawConfig.client_id,
				refresh_token: localStorage.getItem('refresh_token'),
			};

			const newOptions = {
				method: 'POST',
				headers: {
					'Content-Type': 'application/x-www-form-urlencoded',
				},
				data: qs.stringify(obj),
				url: 'https://openhealthboard.auth.us-east-1.amazoncognito.com/oauth2/token'
			};


			const res = await Axios(newOptions);
			const { data } = res;
			const { id_token } = data;
			localStorage.setItem('id_token', id_token);
			options.headers['health-auth'] = id_token;
		}

		// Final query
		res = await Axios(options);
		res.meta = meta;
	} catch (e) {
		console.error('request failed', e.message);
		return {
			success: false,
			error: e,
		};
	}
	return res;
}